import $ from 'jquery'
import selectChoices from './selectChoices'
import debounce from 'debounce'

export default class selectChoicesAjaxSearch extends selectChoices {
    initialize () {
        this.searchUrl = this.$element.data('searchUrl')

        super.initialize()
        this.$element.get(0).addEventListener('search', debounce(async (event) => {
            const searchUrl = this.searchUrl + '?search=' + encodeURIComponent(event.detail.value);
            $.get(searchUrl, (response, status, xhr) => {
                this.choices.setChoices(response, response.value || 'value', response.label || 'label', true)
            }).fail(() => {
                console.error('FEHLER!')
            })
        }, 1000)
        )
    }
}
